export const StatusCard = ({
  title,
  data,
  classNames = "",
  bodyClassNames = "",
}) => {
  return (
    <div className={`card shadow status-response-card w-100 ${classNames}`} data-testid={title}>
      <div className="card-body px-0 mx-0">
        <h5 className="text-center responses-title">{title}</h5>
        <hr />
        <h1 className={`text-center responses ${bodyClassNames}`}>{data}</h1>
      </div>
    </div>
  );
};
